import { DsHeading, FOCUS_RING_CLASSES } from '@frontends/ds';
import { useLocale } from '@frontends/util-i18n';
import { useTranslation } from 'react-i18next';
import { useEntityConfig } from '@/hooks/useEntityConfig';
import { replaceLanguageInUrl } from '../lib/utils';

export const EmptyAccounts = () => {
  const config = useEntityConfig();
  const localeContext = useLocale();
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center min-h-svh px-4 md:px-6">
      <div className="flex flex-col items-center justify-center gap-6">
        <div>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120" width="120" height="120">
            <path
              fill="currentColor"
              fillRule="evenodd"
              d="M23 39a36 36 0 0 1 72 0v13.15l15.1 8.44 2.16 1.2-1.64 1.86-12.85 14.59 3.73 4.03L98.57 85 95 81.13V117H77v-12H67v9H50V95H40v22H23V81.28l-3.8 3.61-2.76-2.9 4.05-3.84-12.77-14.5-1.64-1.86 2.16-1.2L23 52.34V39Zm72 36.33 10.98-12.46L95 56.73v18.6ZM23 56.92v18.03L12.35 62.87 23 56.92ZM59 7a32 32 0 0 0-32 32v74h9V91h18v19h9v-9h18v12h10V39A32 32 0 0 0 59 7Zm-7 36a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm19 3a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
            ></path>
          </svg>
        </div>
        <DsHeading level={1} size="sm">
          {t('noAccountsFound')}
        </DsHeading>
        <div className="text-base text-textSecondary">{t('noAccountsFoundDescription')}</div>
        <a
          href={replaceLanguageInUrl(config.VITE_URL_CREATE_ACCOUNT, localeContext)}
          className={`inline-flex min-w-18 items-center justify-center whitespace-nowrap rounded-md bg-brandPrimary px-3 py-2 text-base font-medium text-textOnBrandPrimary transition hover:bg-brandPrimaryHover active:bg-brandPrimaryActive ${FOCUS_RING_CLASSES}`}
        >
          {t('addAccount')}
        </a>
      </div>
    </div>
  );
};
